import { api , base_url_v1 } from ".";

export const LoginApi = async (formRef:any) => {
    const postData = JSON.stringify({
        IMEI:"PWA-CPUiPhoneOS14_6likeMacOSX-KyF8",
        username:formRef.current['username'].value ,
        password:formRef.current['password'].value ,
    })
    const data = await api({ url: `${base_url_v1}login`, method: "POST" , body:postData })
    return { data };
}


export const HandelApi = async (postData:any , typeScan:any) => {
    let url = typeScan == 'link' ? `${base_url_v1}create-reglog-slug?from=site` : `${base_url_v1}create-reglog`
    const data = await api({ url: url , method: "POST" , body:JSON.stringify(postData) , token:true })
    return { data };
}